<div class="calendar-tab">
  @if (loading()) {
    <p class="regular-14">{{ 'loading' | transloco }}</p>
  } @else if (loadFailed()) {
    <p class="regular-14 color-red">{{ 'cardsAdminCalendarLoadFailed' | transloco }}</p>
  } @else {
    <div class="display-flex vertical gap-16">
      <div class="calendar-header display-flex gap-12">
        <button type="button" class="nav-btn" (click)="prevMonth()">‹</button>
        <span class="semibold-18 month-label">{{ monthLabel() }}</span>
        <button type="button" class="nav-btn" (click)="nextMonth()">›</button>
      </div>

      <div class="kind-toggle display-flex gap-8">
        <button type="button" class="toggle-btn" [class.active]="assignKind() === 'rare'" (click)="setKind('rare')">
          {{ 'cardsAdminCalendarRare' | transloco }}
        </button>
        <button type="button" class="toggle-btn" [class.active]="assignKind() === 'legendary'" (click)="setKind('legendary')">
          {{ 'cardsAdminCalendarLegendary' | transloco }}
        </button>
      </div>

      <div class="calendar-grid">
        @for (label of weekdayLabels(); track $index) {
          <div class="weekday-cell regular-12 color-soft-grey">{{ label }}</div>
        }
        @for (week of weeks(); track $index) {
          @for (cell of week; track $index) {
            <button
              type="button"
              class="day-cell"
              [class.out-of-month]="!cell.inMonth"
              [class.today]="cell.isToday"
              [disabled]="!cell.inMonth || saving()"
              (click)="onDayClick(cell)"
            >
              @if (cell.inMonth) {
                <span class="day-number regular-14">{{ cell.dayNumber }}</span>
                @if (cell.entry; as entry) {
                  <span class="kind-chip semibold-12" [class.rare]="entry.kind === 'rare'" [class.legendary]="entry.kind === 'legendary'">
                    {{ entry.kind === 'rare' ? 'R' : 'L' }}
                  </span>
                }
              }
            </button>
          }
        }
      </div>

      <p class="regular-14 color-soft-grey">
        {{ (data()?.planned ? 'cardsAdminCalendarPlanned' : 'cardsAdminCalendarNotPlanned') | transloco }}
      </p>

      <p class="regular-14 color-soft-grey">{{ 'cardsAdminCalendarHint' | transloco }}</p>

      @if (error(); as err) {
        <p class="regular-14 color-red">{{ err | transloco }}</p>
      }
    </div>
  }
</div>
